import Client from "./Client";

export const findPurchasedTickets = async (orderCode, passKey) => {
  const httpClient = new Client();
  const response = await httpClient.get(`ticket/${orderCode}/${passKey}`);
  return response.data;
};
